import React from 'react';
import { StyledSection, StyledRow } from './styles';

const Section = ({ children, theme, gutters }) => (
  <StyledSection sectionTheme={theme}>
    <StyledRow className="styled-row" gutters={gutters}>{children}</StyledRow>
  </StyledSection>
);

Section.defaultProps = {
  theme: 'white',
  gutters: 'standard',
};

export default Section;
